import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'

import i18n from '@/libs/i18n'
import socketio from 'socket.io-client';
import LottieAnimation from 'lottie-web-vue'
import GeneralMixin from "@/@core/mixins/general";
import VueSocketio from 'vue-socket.io-extended';

// import VueScrollTo from "vue-scrollto";
import VueSmoothScroll from 'vue2-smooth-scroll'

import store from './store'
import App from './App.vue'
import router from './router';

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/element'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
// Vue.use(VueScrollTo, {
//   easing: 'ease-in',
//   lazy: true,
//   offset: 1000,
//   force: true,
// })
Vue.use(VueSmoothScroll, {
  duration: 400,
  updateHistory: false,
})
// Vue.use(VueEasyLightbox)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(LottieAnimation);

const socket = socketio(process.env.VUE_APP_SOCKET_URL, {
  autoConnect: false,
  reconnection: true,
  transports: ["websocket"],
  reconnectionDelay: 500,
  maxReconnectionAttempts: Infinity
});

Vue.use(VueSocketio, socket);
Vue.mixin(GeneralMixin);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
